import React, { FC } from 'react';
import Chip from '@material-ui/core/Chip';
import useStyles from './styles';
import { OrderStatus } from '@src/pages/Deliveries/context/orders';
import { Typography } from '@material-ui/core';
import { Dictionary } from '@src/typings/declarations';

interface IInformationBadgesProps {
  label: string;
  flag: OrderStatus;
  single?: boolean;
  customStyle?: Dictionary<any>;
  avatarImg?: React.ReactElement;
}

export const InformationBadges: FC<IInformationBadgesProps> = ({
  label,
  flag,
  single,
  customStyle,
  avatarImg,
}) => {
  const classes = useStyles();
  return (
    <div className={classes.informationBadges}>
      <Chip
        className={`badge-flag status-${flag} ${single ? 'single' : ''}`}
        size="small"
        label={
          <Typography variant="body1" className="body_small_bold">
            {label}
          </Typography>
        }
        style={customStyle}
        avatar={avatarImg}
      />
    </div>
  );
};

export default InformationBadges;
